import { Company } from "../../core/models/company.model";
import { Hotel } from "../../core/models/hotel.model";

export interface AuthState {
  token: string | null;
  refreshToken: string | null;
  fullName: string;
  expired: boolean;
  loginId: string;
  roles: string[];
  company: Company | null;
  modules: string[];
  loaded: boolean;
  error: string | null;
  allowedHotels?: Hotel[];
}

export const initialAuthState: AuthState = {
  token: null,
  refreshToken: null,
  fullName: '',
  expired: false,
  loginId: '',
  roles: [],
  company: null,
  modules: [],
  loaded: true,
  error: null,
  allowedHotels: [],
};
